import { apiClient } from '@/lib/apiClient';
import type { QueryOptions } from '@/lib/reactQuery';
import type { Id } from '@/types/api';
import { useQuery } from '@tanstack/react-query';

export interface GetAttendanceSessionSummaryResponseData {
  sessionSummary?: {
    id: Id;
    numberOfSkillsMasteredAndCompleted: number;
    numberOfSkillsInProgress: number;
    numberOfPagesCompleted: number;
    numberOfStarsEarned: number;
    didWorkOnAndCheckSchoolwork: boolean;
    didCompleteAndCheckSchoolwork: boolean;
  };
}

export const getAttendanceSessionSummary = async ({ attendanceId }: { attendanceId: Id }) => {
  const response = await apiClient.get<GetAttendanceSessionSummaryResponseData>(`/v1/scheduling/attendance/${attendanceId}/session-summary`);
  return response.data;
};

interface UseGetAttendanceSessionSummaryOptions {
  attendanceId: Id;
  options?: QueryOptions<GetAttendanceSessionSummaryResponseData>;
}

export const GET_ATTENDANCE_SESSION_SUMMARY_QUERY_KEY = 'getAttendanceSessionSummary';

export const useGetAttendanceSessionSummary = ({ attendanceId, options }: UseGetAttendanceSessionSummaryOptions) => {
  return useQuery({
    queryKey: [GET_ATTENDANCE_SESSION_SUMMARY_QUERY_KEY, attendanceId],
    queryFn: () => getAttendanceSessionSummary({ attendanceId }),
    ...options,
  });
};
